import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKOFFICE_URL + '/partners/v1/',
    timeout: 45000,
    withCredentials: true
});

export default axiosInstance;
